import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import type { RootState } from '../../store/store';

export default function Footer() {
  const branding = useSelector((state: RootState) => state.branding);
  const companyName = branding.companyName;
  const website = branding.website;
  const phone = branding.phone;

  return (
    <footer className="bg-app-panel dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-4 flex items-center justify-between flex-wrap gap-2">
          <div className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-3 flex-wrap">
            <span>© {new Date().getFullYear()} {companyName || 'Temperature Monitoring System'}</span>
            {phone && (
              <a href={`tel:${phone.replace(/\s/g, '')}`} className="hover:text-indigo-600 dark:hover:text-indigo-400">
                {phone}
              </a>
            )}
            {website && (
              <a href={website.startsWith('http') ? website : `https://${website}`} target="_blank" rel="noopener noreferrer" className="hover:text-indigo-600 dark:hover:text-indigo-400">
                {website}
              </a>
            )}
          </div>
          <div className="flex items-center gap-3 flex-wrap text-sm text-gray-500 dark:text-gray-400">
            <Link to="/terms" className="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline">
              Terms
            </Link>
            <Link to="/compliance" className="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline">
              Compliance
            </Link>
            <Link to="/privacy" className="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline">
              Privacy
            </Link>
            <Link to="/cookies" className="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline">
              Cookies
            </Link>
            <Link to="/dpa" className="hover:text-indigo-600 dark:hover:text-indigo-400 hover:underline">
              DPA
            </Link>
            <span>Version {__APP_VERSION__}</span>
          </div>
        </div>
      </div>
    </footer>
  );
}